import { render, staticRenderFns } from "./PublicCollection.vue?vue&type=template&id=5e11b3ee&scoped=true&"
import script from "./PublicCollection.vue?vue&type=script&lang=js&"
export * from "./PublicCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e11b3ee",
  null
  
)

export default component.exports